import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewWarehouseCategory, checkWarehouseCategoryExists, updateWarehouseCategory } from '../../../../slices/warehouseCategory/thunk';
import { setRequireCloseModal } from '../../../../slices/warehouseCategory/reducer';
import OInput from '../../../../Components/OElements/OInput';


const CategoryForm = ({
	dataCategory,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const selectorCategory = createSelector(
		state => state.WarehouseCategory,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal
	} = useSelector(selectorCategory);

	// Validation
	const validation = useFormik({
		// Enable reinitialize when initial values need to be changed
		enableReinitialize: true,
		initialValues: {
			name: dataCategory?.name || '',
			disabled: dataCategory?.disabled || false,
		},
		validationSchema: Yup.object({
			name: Yup.string()
				.required('Campo requerido')
				.test('name-exists-check', 'Grupo ya existe', async function (value) {
					if (value) {
						const result = await dispatch(checkWarehouseCategoryExists(value));
						if (result.payload.exists) {
							return this.createError({ message: 'Grupo ya existe' });
						}
					}
					return true;
				}),
		}),
		validateOnChange: true, // Validate on field change
		onSubmit: async values => {
			setIsLoading(true);
			const categoryData = {
				...values,
				...(isEdit && { _id: dataCategory._id }),
			};

			if (isEdit) {
				await dispatch(updateWarehouseCategory(categoryData));
			} else {
				await dispatch(addNewWarehouseCategory(categoryData));
			}
			setIsLoading(false);
		},

	});





	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (validation.isValid) setIsLoading(true);
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				{/* <TabContent activeTab={activeTab}>
					<TabPane tabId='1'> */}
				<Row className='g-3'>
					<Col lg={12}>
						<OInput
							name='name'
							label='Nombre del Grupo'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
				</Row>
				{/* </TabPane>
				</TabContent> */}
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className="label-icon"><Spinner size='sm' /></i>
						)
							: <i className="ri-save-3-line label-icon"></i>
						}
						{isEdit ? 'Editar' : 'Crear'} Grupo
					</button>
				</div>
			</div>
		</Form>
	);
};

export default CategoryForm;
